import { endpoints } from '../endpoints'
import { http } from '../http'
import { ObituarySnippet } from '../../types'

interface ObituariesAPI {
  load: (id: string) => Promise<ObituarySnippet>
}

export const obituaries: ObituariesAPI = {
  load: async (id) => await http.get(`${endpoints.obituaries}/${id}`),
}
